/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './Cms/**/*.blade.php',
    './public/js/app.min.js',
    './public/**/*.html',
    './resources/**/*.blade.php',
    './storage/framework/views/*.php',
  ],
  theme: {
    extend: {
      container: {
        screens: {
          sm: 'none',
          md: 'none',
          lg: 'none',
          xl: 'none',
        },
      },
      fontFamily: {
        SuisseIntl: ['Suisse Intl', 'Arial', 'sans-serif'],
        mariaUnconnected: ['Maria Unconnected', 'sans-serif'],
      },
      colors: {
        default: '#1A1A1A',
        white: '#ffffff',
        'dark-white': '#F0F0F0',
        black: '#1A1A1A',
        red: '#FC491D',
        grey: {
          DEFAULT: '#7A7A7A',
          light: '#BFBFBF',
          medium: '#F0F0F0',
          dark: '#707070',
        },
      },
      borderColor: {
        grey: '#3c3c3c15',
      },
      spacing: {
        0.25: 'calc(var(--rem) / 4)',
        0.5: 'calc(var(--rem) / 2)',
        0.75: 'calc(var(--rem) * 0.75)',
        1: 'var(--rem)',
        1.5: 'calc(var(--rem) * 1.5)',
        2: 'calc(var(--rem) * 2)',
        4: 'calc(var(--rem) * 4)',
        5: 'calc(var(--rem) * 5)',
        5.5: 'calc(var(--rem) * 5.5)',
        6: 'calc(var(--rem) * 6)',
        8: 'calc(var(--rem) * 8)',
        10: 'calc(var(--rem) * 10)',
        12: 'calc(var(--rem) * 12)',
        16: 'calc(var(--rem) * 16)',
        'xl-gap': 'calc(var(--gap) * 3)',
        'lg-gap': 'calc(var(--gap) * 2)',
        'gap': 'var(--gap)',
        'gap-negative': 'calc(var(--gap) * -1)',
        'sm-gap': 'var(--sm-gap)',
        'xs-gap': 'var(--xs-gap)',
        'news-first': 'var(--news-first)',
        'news-width': 'var(--news-width)',
        'span-spacing': 'var(--span-spacing)',
        'programs-width': 'var(--programs-width)',
        'video-position': 'var(--video-position)',
        'section-height': 'var(--section-height)',
      },
      opacity: {
        50: '0.5',
      },
      zIndex: {
        1000: 1000,
      },
    },
    screens: {
      'sm': '320px',
      'md': '500px',
      'lg': '1000px',
      'xl': '1500px',
      '2xl': '2000px',
      'landscape': { raw: '(orientation: landscape)' },
      'portrait': { raw: '(orientation: portrait)' },
    },
    fontSize: {
      title: ['var(--fs-title)', { lineHeight: 'var(--lh-title)' }],
      mtitle: ['var(--fs-mtitle)', { lineHeight: 'var(--lh-mtitle)' }],
      menuitem: ['var(--fs-menuitem)', { lineHeight: 'var(--lh-menuitem)' }],
      redheader: ['var(--fs-red-header)', { lineHeight: 'var(--lh-red-header)' }],
      xl: ['var(--fs-xl)', { lineHeight: 'var(--lh-xl)' }],
      lg: ['var(--fs-lg)', { lineHeight: 'var(--lh-lg)' }],
      xmd: ['var(--fs-xmd)', { lineHeight: 'var(--lh-xmd)' }],
      md: ['var(--fs-md)', { lineHeight: 'var(--lh-md)' }],
      smd: ['var(--fs-smd)', { lineHeight: 'var(--lh-smd)' }],
      sm: ['var(--fs-sm)', { lineHeight: 'var(--lh-sm)' }],
      msm: ['var(--fs-msm)', { lineHeight: 'var(--lh-msm)' }],
      xsm: ['var(--fs-xsm)', { lineHeight: 'var(--lh-xsm)' }],
      xs: ['var(--fs-xs)', { lineHeight: 'var(--lh-xs)' }],
      base: ['var(--fs-base)', { lineHeight: 'var(--lh-base)' }],
      logo: ['var(--fs-logo)', { lineHeight: 'var(--lh-logo)' }],
    },
    lineHeight: {
      15: 'calc(var(--rem) * 15)',
      10: 'calc(var(--rem) * 10)',
      6: 'calc(var(--rem) * 4)',
      4: 'calc(var(--rem) * 4)',
      1: '1',
    },
    borderRadius: {
      'none': '0',
      'full': '9999px',
      'dynamic': 'var(--rounded-dynamic)',
    },
    animation: {
      menu: 'menuUp 0.6s cubic-bezier(0,0,0.1,1) forwards',
    },
  },
  plugins: [
    require('@tailwindcss/typography'),
  ],
}
